import { BillQuery } from '@1bill-app/services/bill/bill.query';
import { BillService } from '@1bill-app/services/bill/bill.service';
import { BillCategoryKey, GetBillOption } from '@1bill-app/services/bill/types';
import { HomeQuery } from '@1bill-app/services/home/home.query';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSearchbar } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ROUTE_HISTORY_PAGE } from '@1bill-app/constants';
/**
 * Page for list of bills for their history.
 */
@Component({
  selector: 'app-history-list',
  templateUrl: './history-list.page.html',
  styleUrls: ['./history-list.page.scss'],
})
export class HistoryListPage implements OnInit {
  @ViewChild(IonSearchbar) searchBar: IonSearchbar;
  public billCategories$ = this.billQuery.billCategories$;
  public isBillLoading$ = this.billQuery.isLoading$;
  public historyBills$ = this.billQuery.historyBills$;
  public paidBillCount$ = this.billQuery.paidBillCount$;

  public filter$ = this.billQuery.select((s) => s?.ui?.historyPageFilter);
  // public billTags$ = this.billQuery.getBillTags(4);
  public billTags$ = this.billQuery.getBillTagsForPage(GetBillOption.PAID_BILLS);
  public pageBillTags;
  public loading$ = this.homeQuery.isLoading$;
  public isPullToRefresh: boolean;
  public noData$ = this.isNoData();
  routeHistoryPage = ROUTE_HISTORY_PAGE;
  constructor(
    private homeQuery: HomeQuery,
    private billQuery: BillQuery,
    private billService: BillService,
    private logger: NGXLogger,
  ) { }

  ngOnInit() {
    this.billService.getBill().subscribe();
    this.billQuery.historyBills$.subscribe((res) => {
      // this.logger.log(res);
    });
  }
  onCatBtnClick(categoryKey: BillCategoryKey) {
    this.billService.updateHistoryPageFilter({ categoryKeys: [categoryKey] });
  }
  onPropertyTagClick(tag: string) {
    this.billService.updateHistoryPageFilter({ propertyTags: [tag] });
  }
  onSearchChange(value: string) {
    this.billService.updateHistoryPageFilter({ query: value });
  }
  doRefresh(event) {
    this.isPullToRefresh = true;
    this.billService.getBill(true).subscribe({
      next: () => {
        this.isPullToRefresh = false;
        event.target.complete();
      },
      error: () => {
        this.isPullToRefresh = false;
        event.target.complete();
      }
    });
  }
  searchSubmit() {
    this.searchBar.getInputElement().then((el) => el.blur());
  }
  isNoData() {
    return combineLatest([this.paidBillCount$, this.isBillLoading$]).pipe(
      map(([paidBillCount, loading]) => {
        return paidBillCount === 0 && !loading;
      }),
    );
  }
}
